import { render, staticRenderFns } from "./FCheckbox.vue?vue&type=template&id=1bacc242&scoped=true"
import script from "./FCheckbox.vue?vue&type=script&lang=ts"
export * from "./FCheckbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bacc242",
  null
  
)

export default component.exports